import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Auth } from 'store/auth/actions';
import PropTypes from 'prop-types';
import { isAuthenicatedSelector } from 'store/auth/selectors';

import './style.scss';

const EmailPageBase = ({ children }) => {
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(isAuthenicatedSelector);
  useEffect(() => {
    dispatch(Auth.authErrorAction(null));
    dispatch(Auth.getPriceTypesList());
  }, [dispatch]);
  if (isAuthenticated) {
    return <Redirect to="/" />;
  }
  return (
    <div className="login-content">
      <div className="email-block">{children}</div>
    </div>
  );
};

EmailPageBase.propTypes = {
  children: PropTypes.node,
};

export { EmailPageBase };
